import { useCallback, useState } from 'react';
import { auctionService } from '../services/auctionService';
export const useAuctionAdmin = () => {
    const [isCreating, setIsCreating] = useState(false);
    const [createError, setCreateError] = useState(null);
    const [analytics, setAnalytics] = useState(null);
    const [analyticsLoading, setAnalyticsLoading] = useState(false);
    const createAuction = useCallback(async (input) => {
        setIsCreating(true);
        setCreateError(null);
        try {
            const result = await auctionService.createAuction(input);
            if (!result.success) {
                setCreateError(result.error || 'Failed to create auction');
            }
            return result;
        }
        catch (err) {
            const error = err.message || 'Failed to create auction';
            setCreateError(error);
            return { success: false, error };
        }
        finally {
            setIsCreating(false);
        }
    }, []);
    const cancelAuction = useCallback(async (auctionId) => {
        try {
            return await auctionService.cancelAuction(auctionId);
        }
        catch (err) {
            return { success: false, error: err.message };
        }
    }, []);
    const supervisedAction = useCallback(async (auctionId, action, payload) => {
        try {
            return await auctionService.supervisedAction({ auctionId, action, payload });
        }
        catch (err) {
            return { success: false, error: err.message };
        }
    }, []);
    const fetchAnalytics = useCallback(async (params = {}) => {
        setAnalyticsLoading(true);
        try {
            const result = await auctionService.getAnalytics(params);
            if (result.success) {
                setAnalytics(result.data);
            }
            return result;
        }
        catch (err) {
            return { success: false, error: err.message };
        }
        finally {
            setAnalyticsLoading(false);
        }
    }, []);
    return {
        // Create
        createAuction,
        isCreating,
        createError,
        // Admin actions
        cancelAuction,
        supervisedAction,
        // Analytics
        analytics,
        analyticsLoading,
        fetchAnalytics,
    };
};
